import {NavigationRouteProps} from './../../../../shared/routing/model';
import {ProfileDesktopApplications} from '../../desktop/components/applications';
import {ProfileMobileApplications} from '../../mobile/components/applications';
import {ApplicationsProps} from './model';
import {NavigationHelpers, ParamListBase, useNavigation, useRoute} from '@react-navigation/native';
import {Screens} from '../../../../shared/routing';
import React, {useEffect, useState} from 'react';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {useSelector} from 'react-redux';
import {profileApplicationsSelector} from '../../../../redux/selectors/profile';
import {getFormValues} from 'redux-form';
import {Forms} from '../../../../shared/models/forms';
import {filterApplicationsList} from '../filter';
import {usePartialList} from '../../../../shared/hooks/usePartialList';
import {Platform} from 'react-native';
import {defaults} from '../../../../shared/constants/defaults';

export const ProfileApplications = () => {
  const isDesktop = useIsDesktop();
  const nav = useNavigation() as unknown as NavigationHelpers<ParamListBase>;
  const route: NavigationRouteProps<{'application-id'?: string}> = useRoute();
  const [filter, setFilter] = useState<any>({});

  const stateFilter = useSelector(getFormValues(Forms.applicationsFilterForm));

  const allApplications = useSelector(profileApplicationsSelector(filterApplicationsList(filter)));

  const [applications, showMoreApplications, allApplicationsShown] = usePartialList(
    allApplications,
    Platform.OS === 'web' ? defaults.partialListSizeWithButton : defaults.partialListSizeWithScroll,
  );

  const showMoreApplicationsWrap = () => {
    if (!allApplicationsShown) {
      showMoreApplications();
    }
  };

  useEffect(() => {
    if (stateFilter && !isDesktop) {
      setFilter(stateFilter);
    }
  }, [stateFilter]);

  useEffect(() => {
    if (stateFilter && isDesktop) {
      setFilter(stateFilter);
    }
  }, [isDesktop]);

  useEffect(() => {
    const appId = route?.params?.['application-id'];
    if (appId) {
      nav.navigate(Screens.ProfileApplicationsItem, {
        'application-id': appId,
      });
    }
  }, []);

  const props: ApplicationsProps = {
    applications: applications,
    allShown: allApplicationsShown,
    onLoadMore: showMoreApplicationsWrap,
    onPressShowFilter() {
      if (!isDesktop) {
        nav.navigate(Screens.ProfileApplicationsFilter);
      }
    },
    onApplyFilter(formData) {
      setFilter(formData);
    },
    onPressItem(application) {
      if (isDesktop) {
        nav.setParams({
          'application-id': String(application.id),
        });
      } else {
        nav.navigate(Screens.ProfileApplicationsItem, {
          'application-id': String(application.id),
        });
      }
    },
  };

  return React.createElement(isDesktop ? ProfileDesktopApplications : ProfileMobileApplications, props);
};
